module.exports = __webpack_public_path__ + "static/media/logo-blue.ba3bad65.png";